import React from "react";
import "./ExclusionOfLiabillty.css";

const ExclusionOfLiabillty = () => {
  return (
    <div className="exclusionOfLiabillty_parent_div">
      <h1>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptatibus
        reiciendis, sint nesciunt laboriosam temporibus cum, facere sunt, harum
        quia fugit ea sequi doloribus nemo consequuntur velit sed! Harum, error
        obcaecati!
      </h1>
    </div>
  );
};

export default ExclusionOfLiabillty;
